import { api } from '../api';
import type {
  ExtractSlidesDto,
  ExtractSlidesResponse,
  SlideExtractionJob,
  SlideExtractionJobType,
  SlideItem,
} from './slides.types';

export const extractSlides = async (
  dto: ExtractSlidesDto,
): Promise<ExtractSlidesResponse> => {
  const response = await api.post<ExtractSlidesResponse>('/slides/extract', dto);
  return response.data;
};

export const extractBundle = async (
  dto: ExtractSlidesDto,
): Promise<ExtractSlidesResponse> => {
  const response = await api.post<ExtractSlidesResponse>('/slides/extract-bundle', dto);
  return response.data;
};

export const getSlidesJob = async (
  resourceId: number,
  jobType?: SlideExtractionJobType,
): Promise<SlideExtractionJob> => {
  const params = jobType ? { jobType } : {};
  const response = await api.get<SlideExtractionJob>(
    `/slides/resource/${resourceId}/job`,
    { params },
  );
  return response.data;
};

export const getSlides = async (resourceId: number): Promise<SlideItem[]> => {
  const response = await api.get<SlideItem[]>(`/slides/resource/${resourceId}`);
  return response.data;
};

/**
 * Replaces the image for a single slide page.
 *
 * Routed through the shared `api` axios instance so it gets Bearer-token
 * attachment and single-flight 401 refresh-and-retry like every other
 * call. The instance's default `Content-Type: application/json` header is
 * explicitly unset for this request: axios's transformRequest otherwise
 * JSON.stringifies a FormData body when it sees a JSON content type,
 * instead of leaving it for the browser/XHR to send as multipart with an
 * auto-computed boundary.
 */
export const replaceSlide = async (
  slideId: number,
  file: File,
): Promise<SlideItem> => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.put<SlideItem>(
      `/slides/${slideId}/replace`,
      formData,
      {
        headers: { 'Content-Type': undefined },
      },
    );
    return response.data;
  } catch (error: any) {
    const errorData = error?.response?.data;
    const message =
      (errorData?.message || errorData?.error || errorData?.detail || '')
        .toString() ||
      error?.message ||
      'Error al reemplazar la imagen';

    throw new Error(message);
  }
};
